import { render, staticRenderFns } from "./enColumn.vue?vue&type=template&id=08f8cf7a&scoped=true"
import script from "./enColumn.vue?vue&type=script&lang=js"
export * from "./enColumn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08f8cf7a",
  null
  
)

export default component.exports